import script from "./content-order.vue?vue&type=script&setup=true&lang=js"
export * from "./content-order.vue?vue&type=script&setup=true&lang=js"

import "./content-order.vue?vue&type=style&index=0&id=de0bface&lang=scss"

const __exports__ = script;

export default __exports__